/** @format */

import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { CategoryDetails } from '@plp/data-access/interfaces';
import { FilterOptionComponent } from '../filter-option/filter-option.component';
import { HmfActionTextComponent } from '@dsg-tech/homefield-angular';
import { StandardFilterComponent } from '../standard-filter/standard-filter.component';

@Component({
  selector: 'plp-components-category-filter',
  imports: [FilterOptionComponent, HmfActionTextComponent],
  templateUrl: './category-filter.component.html',
  styleUrl: './category-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryFilterComponent extends StandardFilterComponent {
  defaultOpen = input<boolean>(false);
  isPlp3Template = input<boolean>(false);
  categoryDetails = input<CategoryDetails | undefined>({});

  ariaLabels = computed<string[]>(() => {
    return this.filterOptions()?.map((filterOption) => {
      const categoryName =
        this.categoryDetails()?.[filterOption?.value]?.name ?? filterOption?.value;
      const categoryCount = filterOption?.count;
      const isSelected = this.selectedOptions()?.includes(filterOption?.value)
        ? 'selected'
        : 'not selected';
      return `${categoryName}. ${categoryCount} products. ${isSelected}`;
    });
  });

  displayValues = computed<string[]>(() => {
    return this.filterOptions()?.map((filterOption) => {
      return this.categoryDetails()?.[filterOption?.value]?.name ?? filterOption?.value;
    });
  });
}
